export const MODAL_TRIGGER = 'MODAL_TRIGGER';

export const modalTrigger = (isOpen, component, persist = false, payload) => ({
    type: MODAL_TRIGGER,
    payload: {
        payload: payload,
        isOpen: isOpen,
        component: component,
        persist: persist,
    },
});
